import React from "react";
// import {GeneralCont} from "../styleLogin";
import LoginLogo from "../../../components/login/loginLogo";
import {ButtonLogin} from "../../../routes/buttons";
import {TopBar} from "../../../routes/TopBars";
import {ReactComponent as Arrow} from "../../../assets/icons/back_shape.svg";
import {ResetButton} from "../../../styles/Butttons";
import {ForgotPasswordService} from "../../../services/UserServices";

export default function ForgotPassword({back}) {
   const sendEmail = e => {
      e.preventDefault();
      console.log();
      ForgotPasswordService({email: e.target.email.value})
         .then(res => res.json())
         .then(resp => {
            console.log(resp);
         });
   };

   return (
      <>
         <TopBar>
            <ResetButton onClick={back} className="styleArrow">
               <Arrow />
            </ResetButton>
            <div className="ttitle">
               <p className="">REstaurar contraseña</p>
            </div>
         </TopBar>
         <LoginLogo></LoginLogo>
         <div>
            <form onSubmit={sendEmail}>
               <label htmlFor="nombre"></label>
               <input className="styleInput" name="email" type="email" placeholder="E-mail" />
               <br />

               <ButtonLogin>ENVIAR</ButtonLogin>
               {/* <label htmlFor="contraseña"></label>
               <input className="styleInput" name="contraseña" type="text" placeholder="Contraseña" /> */}
            </form>
         </div>
      </>
   );
}
